export type HubspotObjectListKey = "PRIMARY" | "SECONDARY_DEAL" | "SECONDARY_CONTACT" | "OBJECT_LIBRARY" | "CUSTOM_OBJECTS";

export interface HubspotObject {
  id: string;
  name: string;
  enabled: boolean;
}

export interface HubspotObjectList {
  key: HubspotObjectListKey;
  objects: Array<HubspotObject>;
}

const hsObjectTypes: Array<HubspotObjectList> = [
  {
    "key": "PRIMARY",
    "objects": [
      {
        "id": "0-1",
        "name": "Contacts",
        "enabled": true
      },
      {
        "id": "0-2",
        "name": "Companies",
        "enabled": true
      },
      {
        "id": "0-3",
        "name": "Deals",
        "enabled": true
      },
      {
        "id": "0-5",
        "name": "Tickets",
        "enabled": true
      }
    ]
  },
  {
    "key": "OBJECT_LIBRARY",
    "objects": [
      {
        "id": "0-421",
        "name": "Appointments",
        "enabled": false
      },
      {
        "id": "0-410",
        "name": "Courses",
        "enabled": false
      },
      {
        "id": "0-420",
        "name": "Listings",
        "enabled": false
      },
      {
        "id": "0-162",
        "name": "Services",
        "enabled": false
      },
      {
        "id": "0-14",
        "name": "Quotes",
        "enabled": false
      }
    ]
  },
  {
    "key": "CUSTOM_OBJECTS",
    "objects": []
  },
  {
    "key": "SECONDARY_CONTACT",
    "objects": []
  },
  {
    "key": "SECONDARY_DEAL",
    "objects": []
  }
]

export default hsObjectTypes;